import { PromotionSaleDetailPage } from './PromotionSaleDetailPage'
import { withPromotionSaleDetailPage } from './withPromotionSaleDetailPage'

const ConnectedPromotionSaleDetailPage = withPromotionSaleDetailPage(
  PromotionSaleDetailPage
)

export { ConnectedPromotionSaleDetailPage as PromotionSaleDetailPage }
